import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Section from '../../../shared/Section/Section';
import styles from './styles';

function Schedule({ title, subtitle, images, list }) {
  return (
    <Section title={title} subtitle={subtitle} withoutBg>
      <Grid container pt={{ xs: 1, sm: 0 }}>
        {list.map((item, index) => (
          <Grid
            key={index}
            item
            xs={11}
            md={11.5 / list.length}
            sx={styles.item}
          >
            <Box sx={{ minHeight: { xs: 0, xl: 190 } }}>
              {item.time && (
                <Typography variant="desktopP3" sx={styles.time}>
                  {item.time}
                </Typography>
              )}
              {item.topic && (
                <Typography variant="desktopH5" sx={styles.topic}>
                  {item.topic}
                </Typography>
              )}
              {item.period && (
                <Typography
                  component="div"
                  variant="desktopP3"
                  sx={styles.period}
                >
                  {item.period}
                </Typography>
              )}
            </Box>
            <Box sx={styles.image}>
              {item.image && (
                <GatsbyImage
                  className="story-avatar"
                  image={getImage(images[`schedule/${item.image}`])}
                  alt=""
                  loading="lazy"
                />
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}

export default Schedule;
